import { PillToggle } from "@/components/campaignBuilder/design/PillToggle";

interface SkipUnboxingUnlockedProps {
  checked: boolean;
  onChange: (v: boolean) => void;
}

export function SkipUnboxingUnlocked({ checked, onChange }: SkipUnboxingUnlockedProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>
        <div
          className="font-lato font-bold uppercase text-rodeo-black"
          style={{ fontSize: 13, letterSpacing: "0.5px", marginBottom: 2 }}
        >
          Skip Unboxing
        </div>
        <div
          className="font-lato"
          style={{ fontSize: 12, color: "var(--color-graphite)", lineHeight: 1.4 }}
        >
          Recipients will go straight to the gift selection page without seeing the unwrap
          animation.
        </div>
      </div>
      <PillToggle checked={checked} onChange={onChange} aria-label="Skip unboxing animation" />
    </div>
  );
}
